import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Label.css';
var cx = classnames.bind(styles); // Wouldn't we be fine without "htmlFor" being a prop and let it be applied using {...rest}???
// NO. React will only handle the htmlFor prop if it is explicitly set on a native label element.
// If it is passed through using a spread operator, it will not get parsed correctly

function Label(_ref) {
  var className = _ref.className,
      htmlFor = _ref.htmlFor,
      inline = _ref.inline,
      hidden = _ref.hidden,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "htmlFor", "inline", "hidden", "children"]);

  return (// eslint-disable-next-line
    React.createElement("label", _extends({
      className: cx('label', {
        inline: inline
      }, {
        hidden: hidden
      }, className),
      htmlFor: htmlFor
    }, rest), children)
  );
}

Label.propTypes = {
  className: PropTypes.string,
  inline: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.string]).isRequired,
  hidden: PropTypes.bool,
  htmlFor: PropTypes.string
};
Label.defaultProps = {
  className: undefined,
  inline: false,
  hidden: false,
  htmlFor: undefined
};
export default React.memo(Label);